import { Typography } from '@iheartjane/reefer';
import type { ReactNode } from 'react';

import { useTextField } from './text-field-context';

export const HelperText = ({
  id,
  children,
}: {
  children: ReactNode;
  id: string;
}) => {
  const { error, success } = useTextField();
  return (
    <Typography
      id={id}
      color={error ? 'error' : success ? 'success' : 'text-light'}
      as="div"
      data-testid={id}
      variant="body"
      role={error ? 'alert' : undefined}
    >
      {children}
    </Typography>
  );
};
